/* global axios */
import ApiClient from './ApiClient';

class HubAPI extends ApiClient {
  constructor() {
    super('hub', { apiVersion: 'v2' });
  }

  getClaudiaProjects() {
    return axios.get(`${this.url}/claudia_projects`);
  }

  getEddieWorkspaces() {
    return axios.get(`${this.url}/eddie_workspaces`);
  }
}

export default new HubAPI();
